export const COPILOT_MARKDOWN_ELEMENTS: string[] = [
  "a",
  "blockquote",
  "br",
  "code",
  "del",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "hr",
  "li",
  "ol",
  "p",
  "pre",
  "strong",
  "ul",
];

export function safeCopilotHref(href: string, appOrigin: string): string | null {
  const candidate = href.trim();
  if (!candidate || candidate.startsWith("//")) return null;
  try {
    const base = new URL(appOrigin);
    const destination = new URL(candidate, base);
    if (
      (destination.protocol !== "http:" && destination.protocol !== "https:") ||
      destination.origin !== base.origin
    ) {
      return null;
    }
    return destination.toString();
  } catch {
    return null;
  }
}
